import { render, staticRenderFns } from "./fuWuLocationAdd.vue?vue&type=template&id=6da70840&scoped=true&"
import script from "./fuWuLocationAdd.vue?vue&type=script&lang=ts&"
export * from "./fuWuLocationAdd.vue?vue&type=script&lang=ts&"
import style0 from "./fuWuLocationAdd.vue?vue&type=style&index=0&id=6da70840&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da70840",
  null
  
)

export default component.exports